import { Route } from '@angular/router';

export const CustomerRoutes: Route[] = [
  {
    path: 'customer',
    children: [
      {
        path: 'notice',
        children: [
          {
            path: '',
            loadComponent: () => import('../pages/customer/notice/notice.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('../pages/customer/notice/notice-detail/notice-detail.page'),
          },
        ],
      },
      {
        path: 'inquiry',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../pages/customer/inquiry/inquiry.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('../pages/customer/inquiry/inquiry-detail/inquiry-detail.page'),
          },
        ],
      },
      {
        path: 'faq',
        children: [
          {
            path: '',
            loadComponent: () => import('../pages/customer/faq/faq.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('../pages/customer/faq/faq-detail/faq-detail.page'),
          },
        ],
      },
    ],
  },
];
